module.exports = __webpack_public_path__ + "img/spsf_sample.2b96e476.png";